module.exports = __webpack_public_path__ + "img/pic_new_features_4.5a8b25c2.png";